import React from 'react'
import Icon from 'react-icon-base'

const ArrowRightIcon = props => (
  <Icon viewBox="0 0 40 40" {...props}>
    <g>
      <path d="m6.5 21.6v-3.2h20.3l-9.3-9.4 2.4-2.4 13.3 13.4-13.3 13.4-2.5-2.4 9.4-9.4h-20.3z" />
    </g>
  </Icon>
)

export default ArrowRightIcon
